/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useEffect, useId, useMemo, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, Box, Grid, Avatar } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Loading from '../../../../../../components/Common/Loaders/FullWidthLoader/Loading';
import { LanguageContext } from '../../../../../../libs/Context';
import { feedActionContext } from '../../../..';
import { catchErr, DateDiff, userInfo } from '../../../../../../libs/HelperContent';
import { reportFeed } from '../../../../../actions/feeds_actions_new';
import ReadMoreLess from '../../../Reusable/ReadMoreLess/Readmoreless';
import { feedActionContextFromExternal } from '../../../ExternalRequest';
import ProfilePic from '../../../../../../components/Common/ProfilePic';

const ReportFeeds = (props:any) =>
{
	const { open, onClose, reportedFeedData, reportedFeedIndex, contextT } = props;
	const reportOptions = [
		'Harassment', 'Fraud or spam', 'Scam', 'Report abuse', 'Law',
		'Threats & violence', 'Graphic content', 'Fake account', 'Sexual content', 'Dont like',
		'illegal goods & services', 'Self-harm', 'Hateful speech', 'Misinformation'
	];
	const baseUrl = process.env.REACT_APP_S3_BASE_URL;
	const randomId = useId();
	// Context Action
	const { handleFeedAction } = useContext(contextT === 'external' ? feedActionContextFromExternal : feedActionContext); // report action for Feed & External Module.
	const { language } = useContext(LanguageContext);
	// Redux
	const userData = useSelector((state:any) => state?.mysession?.session);
	// State
	const [ selectedReport, setSelectedReport ] = useState<any>('');
	const [ reportTxt, setReportTxt ] = useState<any>('');
	const [ loading, setLoading ] = useState<boolean>(false);

	const handleOptionClick = (option) =>
	{
		setSelectedReport(option === selectedReport ? '' : option);
		reportTxt !== '' && setReportTxt('');
	};

	// POST-API
	const postReport = async () =>
	{
		if (!loading)
		{
			setLoading(true);
			try
			{
				const query = {
					uid     : userData?.userId,
					comid   : userData?.companyId,
					empRole : userData?.empRole,
					role    : userData?.role
				};
				const body = {
					feedId   : reportedFeedData?._id,
					title    : selectedReport || reportTxt,
					userData : userInfo(userData)
				};
				const res = await reportFeed(body, query);

				if (res?.status)
				{
					toast.success(language.feedReportedSuccessfully, {
						position  : toast.POSITION.TOP_RIGHT,
						className : 'toast-message'
					});
					handleFeedAction('append', 'report_tag', { ...reportedFeedData, index: reportedFeedIndex, reportId: res?.data?._id });
					setLoading(false);
					onClose();
				}
			}
			catch (err)
			{
				console.log(err);
				catchErr(err);
				setLoading(false);
				onClose();
			}
		}
	};

	useEffect(() =>
	{
		setSelectedReport('');
		setReportTxt('');
	}, [ reportedFeedData?._id ]);

	// Avatar
	const avatarSrc = useMemo(() =>
		`${baseUrl}/profile/${reportedFeedData?.createdBy}_profile.jpeg` || '/images/icons/defaultUser.svg',
	[ baseUrl, reportedFeedData?.createdBy ]
	);

	// Caches computed values and reduce unnecessary re-renders
	const isButtonDisabled = useMemo(() =>
		selectedReport === '' && reportTxt?.trim() === '',
	[ selectedReport, reportTxt ]
	);

	return (
		<Dialog open={open} onClose={onClose}>
			{loading && <Loading/>}
			<DialogTitle sx={{ padding: '16px 16px 8px 16px' }}>
				<Grid container flexWrap='nowrap' spacing={1} alignItems={'flex-start'}>
					<Grid item sx={{ flexShrink: 0 }} alignItems='start' display={'flex'}>

						{/* <Avatar
							src={avatarSrc}
							sx={{ width: '32px', height: '32px', border: '1px solid rgba(0,0,0,0.12)', borderRadius: '50%' }}
						/> */}
						<Box
							sx={{
								width          : 'var(--pixel40)',
								height         : 'var(--pixel40)',
								borderRadius   : 'var(--percent50)',
								border         : '1px solid var(--brdrBlackColor)',
								alignItems     : 'center',
								justifyContent : 'center'
							}}
						>
							<ProfilePic
								imagePath={`${[ 'employee', 'individual' ].includes(reportedFeedData?.userData?.role)
									? `${reportedFeedData?.createdBy}.jpeg`
									: `${reportedFeedData?.createdBy}_logo.jpeg`}?t=${new Date().valueOf()}`}
								defaultImg={([ 'employee', 'individual' ].includes(reportedFeedData?.userData?.role) ? '/images/icons/defaultUser.svg' : '/images/logos/no_logo.png')}
								alt={language.createdBy}
								className='brdrRadius50'
								from={[ 'employee', 'individual' ].includes(reportedFeedData?.userData?.role) ? 'selfProfile' : ''}
							/>
						</Box>
					</Grid>
					<Grid item xs sx={{ minWidth: 0, overflow: 'hidden', lineHeight: 0.5 }} >
						<Box sx={{ width: '100%', overflow: 'hidden' }}>
							<Typography
								variant='subtitle1'
								fontWeight='500'
								sx={{
									whiteSpace   : 'nowrap',
									overflow     : 'hidden',
									textOverflow : 'ellipsis',
									width        : '100%',
									lineHeight   : 1.2
								}}
							>
								{reportedFeedData?.userData?.fullName ?? reportedFeedData?.userData?.companyName ?? 'NA'}
							</Typography>
							<Typography fontSize={'var(--pixel12)'} component={'span'} color={'rgba(178, 178, 178, 1)'}>
								{DateDiff(reportedFeedData?.updatedAt || reportedFeedData?.createdAt, new Date().valueOf())}
							</Typography>
						</Box>
					</Grid>
					<Grid item sx={{ flexShrink: 0 }} alignItems={'start'} display={'flex'} >
						<CloseIcon onClick={onClose} fontSize='small' sx={{ color: '#000', cursor: 'pointer' }} />
					</Grid>
				</Grid>
				{/* <Box pt={1}>
					<ReadMoreLess
						text={reportedFeedData?.description}
						maxChars={200}
						fontSize='16px'
						fontWeight={400}
						textColor='#5D5D5D'
						buttonColor='#24A4C4'
					/>
				</Box> */}
			</DialogTitle>
			<DialogContent
				sx={{
					padding                : '16px',
					overflowY              : 'auto',
					scrollbarWidth         : 'none',
					'&::-webkit-scrollbar' : { display: 'none' }
				}}
			>
				<Grid item xs={12}>
					<Box bgcolor='#fff' borderRadius={3.5} width={'100%'}>
						<Box pt={1}>
							<ReadMoreLess
								text={reportedFeedData?.description}
								maxChars={200}
								fontSize='16px'
								fontWeight={400}
								textColor='#5D5D5D'
								buttonColor='#24A4C4'
							/>
						</Box>
						<Grid container spacing={2} py={1}>
							{reportOptions?.map((option) => (
								<Grid item key={option}>
									<Box
										onClick={() => handleOptionClick(option)}
										sx={{
											backgroundColor : selectedReport === option ? '#24a4c4' : 'rgba(0, 0, 0, 0.08)',
											color           : selectedReport === option ? 'white' : 'rgba(0, 0, 0, 0.87)',
											'&:hover'       : { backgroundColor: selectedReport === option ? '#1c7e96' : 'rgba(0, 0, 0, 0.12)' },
											textTransform   : 'none',
											borderRadius    : '16px',
											padding         : '4px 10px',
											fontSize        : 'var(--pixel12)',
											height          : '28px',
											display         : 'flex',
											alignItems      : 'center',
											justifyContent  : 'center',
											position        : 'relative',
											minWidth        : 'auto',
											fontWeight      : 500,
											cursor          : 'pointer'
										}}
									>
										<Box component='span' sx={{ marginLeft: selectedReport === option ? '20px' : '0', marginRight: selectedReport === option ? '4px' : '0' }}>
											{option}
										</Box>
										{selectedReport === option && (
											<DoneIcon sx={{ position: 'absolute', left: 8, fontSize: 16, marginRight: '4px' }} />
										)}
									</Box>
								</Grid>
							))}
						</Grid>
						<Box>
							<Typography variant='subtitle2' color='#043040' gutterBottom pt={1}>
								{language.others}
							</Typography>
							<Typography variant='subtitle1' color='#043040' fontWeight={500}>
								{language?.reportPostFeed}
							</Typography>
							<Typography variant='caption' color='#737373' paragraph fontWeight={500}>
								{/* {language?.reportExplanation} */}
								Help us understand the issue so our platform administrators can take appropriate action
							</Typography>
							<TextField
								fullWidth
								multiline
								rows={3}
								value={reportTxt}
								disabled={selectedReport !== ''}
								onChange={(e) => setReportTxt(e?.target?.value?.replace(/^\s+/, ''))}
								variant='outlined'
								inputProps={{ maxLength: 250 }}
								placeholder={language?.writeAboutWords}
							/>
						</Box>
					</Box>
				</Grid>
			</DialogContent>
			<DialogActions sx={{ padding: '16px' }}>
				<Button onClick={onClose} variant='outlined'>{language.cancel}</Button>
				<Button
					onClick={postReport}
					variant='contained'
					sx={{
						backgroundColor : isButtonDisabled ? 'rgba(0,0,0,0.12)' : '#24a4c4',
						'&:hover'       : {
							backgroundColor : isButtonDisabled ? 'rgba(0,0,0,0.12)' : '#1c7e96'
						},
						color : '#fff'
					}}
					disabled={isButtonDisabled}
				>
					{language?.report}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ReportFeeds;
